import { Injectable, OnInit, Injector } from '@angular/core';
import {ParserService } from '../ws/ws.service';
import {environment} from '../../../../environments/environment';
import {IRecordingParser} from './recording-parser';
import {IRecordingManager, OnRecording} from './recording-manager';
import {WsService2} from '../ws/ws.service';
@Injectable()
export class RecordingParserService extends ParserService implements IRecordingParser{
    constructor(ws: WsService2){ 
       super(ws);
    }
    
    setManager(r:IRecordingManager){
        this.manager = r;
    }
    manager: IRecordingManager
    parseMessage(m){
       switch (m.cmd){
       
           case "recordingStarted": this.recordingStarted(m); break;
           case "recordingStopped": this.recordingStopped(m); break;
          
        }
    }
   onDisconnected(){
       this.manager.onDisconnected();
   }
   sendRecording(recording, recordId, states=null, sessionId){
       this.send("recording", {start: recording, recordId: recordId, states: states, sessionId: sessionId});
   }
    recordingStarted(m){
        this.manager.recordingStarted(m.recordId, m.filename);
   }
    recordingStopped(m){
        this.manager.recordingStopped(m.recordId);
   }
   sendCurrentState(state, board, recordId){
        this.send("setRecordingCurrentState", {currentState: state, id: board.pageId, recordId: recordId});
   }
}



// WEBPACK FOOTER //
// /app/src/app/wb/services/recording/recording-parser.service.ts